import { useCallback } from 'react';
import { useLocalStorage } from 'hooks/useLocalStorage';

interface Viewer {
  id: string;
  email: string | null;
  commentsStatus: 'default' | 'pending' | 'completed';
}

export const useViewerInfo = () => {
  const [viewer, setViewer] = useLocalStorage<Viewer>('viewer', { id: '', email: '', commentsStatus: 'default' });

  const setViewerEmail = useCallback(
    (email: string) => {
      setViewer((identifiedViewer: Viewer) => ({ ...identifiedViewer, email: email }));
    },
    [setViewer]
  );

  const setViewerDetails = useCallback(
    (id: string, email: string | null, commentsStatus?: 'pending' | 'completed') => {
      setViewer({ id, email: email, commentsStatus: commentsStatus || 'default' });
    },
    [setViewer]
  );

  const clearViewerEmail = useCallback(() => {
    setViewer((identifiedViewer: Viewer) => ({ ...identifiedViewer, email: '' }));
  }, [setViewer]);

  const setCommentsStatus = useCallback(
    (commentsStatus: 'pending' | 'completed') => {
      setViewer((identifiedViewer: Viewer) => ({ ...identifiedViewer, commentsStatus }));
    },
    [setViewer]
  );

  return { viewer, setViewerEmail, clearViewerEmail, setViewerDetails, setCommentsStatus };
};
